import React, { useState, useContext, useEffect } from "react";
import "../styles/Result.css";
import SendProfile from "../assets/boticon.png";
import Regenerate from "../assets/regenerate.png";
import { GenerationContext } from "../context/GenerationContext";
import { generateImage, uploadImageGeneration } from "../helper";
import { db } from "../firebaseConfig";
import { doc, setDoc } from "firebase/firestore";

const Result = () => {
  const [generatedImages, setGeneratedImages] = useState([]);
  const [selectedImageId, setSelectedImageId] = useState(null);
  const [points, setPoints] = useState(localStorage.getItem("points") || 0);
  const [user] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [loading, setLoading] = useState(false);
  const {
    text,
    setText,
    promptValue,
    styleValue,
    negativePrompt,
    cfgValue,
    stepsValue,
    imageText,
    image,
    strength,
    control,
  } = useContext(GenerationContext);

  useEffect(() => {
    setPoints(localStorage.getItem("points"));
  }, [points]);

  useEffect(() => {
    if (text !== "") {
      setGeneratedImages((prevImages) => {
        if (!prevImages.some((image) => image.src === text)) {
          const newImage = {
            id: prevImages.length,
            src: text,
          };
          setSelectedImageId(newImage.id);
          return [newImage, ...prevImages];
        }
        return prevImages;
      });
    }
  }, [text]);

  const handleRegenerate = async () => {
    setPoints(localStorage.getItem("points"));
    console.log(
      "Points in local storagee start: ",
      localStorage.getItem("points")
    );
    if (!user) {
      alert("User not logged in. Please log in to generate images.");
      return;
    }
    if (points < 2) {
      alert("Not enough points to generate an image.");
      return;
    }
    setLoading(true);

    try {
      if (imageText === "text") {
        const image = await generateImage(promptValue, styleValue);
        setText(image);
      } else {
        const text = await uploadImageGeneration(
          promptValue,
          styleValue,
          image,
          "remix",
          strength,
          control,
          stepsValue,
          cfgValue,
          negativePrompt
        );
        setText(text);
      }
      const newPoints = localStorage.getItem("points") - 2;
      setPoints(newPoints);

      localStorage.setItem("points", newPoints);
      console.log("Updated points result:", newPoints);
      console.log("Points in local storagee: ", localStorage.getItem("points"));
      const pointsEvent = new CustomEvent("pointsUpdated", {
        detail: { points: newPoints },
      });
      window.dispatchEvent(pointsEvent);

      try {
        const userDocRef = doc(db, "users", user.uid);
        await setDoc(userDocRef, { points: newPoints }, { merge: true });
        console.log("Points updated successfully in Firestore!");
      } catch (error) {
        console.error("Error updating Firestore document:", error);
      }
    } catch (error) {
      console.error("Error regenerating:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageClick = (image) => {
    setText(image.src);
    setSelectedImageId(image.id);
  };

  return (
    <div className="result-container">
      <div className="result-box">
        <div className="result-header">
          <img src={SendProfile} alt="icon" className="result-icon" />
          <p className="result-text">
            Certainly! Your visual representation has been created using the
            provided prompt.
          </p>
        </div>
        <div className="result-image-container">
          {text ? (
            <img
              src={text}
              alt="Result not Generated yet..."
              className="result-image"
            />
          ) : (
            <p className="no-image-text">No image generated</p>
          )}
        </div>
        {generatedImages.length > 0 && (
          <div className="generated-images-scroll-container">
            <div className="generated-images-container">
              {generatedImages.map((image) => (
                <img
                  key={image.id}
                  src={image.src}
                  alt={`No Result ${image.id}`}
                  className={`generated-image ${
                    selectedImageId === image.id ? "selected" : ""
                  }`}
                  onClick={() => handleImageClick(image)}
                />
              ))}
            </div>
          </div>
        )}
        <div className="result-footer">
          <button className="regenerate-button" onClick={handleRegenerate}>
            <img
              src={Regenerate}
              alt="Regenerate Icon"
              className="regenerate-icon"
            />
            {loading ? "Regenerating..." : "Regenerate"}{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Result;
